import moment from "moment";
import BrandPortfolioStrategyMixin from "@/mixins/BrandPortfolioStrategyMixin.vue";
export default {
  name: "BrandPortfolioAggregateMixin",
  mixins: [BrandPortfolioStrategyMixin],
  methods: {
    sumOverChildren(children, valueOf) {
      const values = children.map(child => valueOf(child)).filter(value => value != null);
      if (values.length === 0) return null;
      return values.reduce((total, value) => total + value, 0);
    },
    aggregatePpcStatus(children) {
      return children.some(child => child.ppc_status != null) ? "OK" : null;
    },
    aggregateForecast(children) {
      return this.sumOverChildren(children, child => child.ppc_forecast);
    },
    aggregateSpend(children) {
      return this.sumOverChildren(children, child => child.ppc_spend);
    },
    aggregateWeeklyBudget(children) {
      return this.sumOverChildren(children, child => this.ppcWeeklyBudget(child));
    },
    aggregateForecastShareOfBudget(children) {
      return this.computePpcForecastShareOfBudget(this.aggregateForecast(children), this.aggregateWeeklyBudget(children));
    },
    aggregateForecastStatus(children) {
      return this.computePpcForecastStatus(this.aggregateForecast(children), this.aggregateWeeklyBudget(children));
    },
    nearestDaysToNewStrategy(children) {
      const days = children.map(child => this.getDaysToNewStrategy(this.ppcStrategyEndDate(child), moment())).filter(value => value !== null);
      if (days.length === 0) return null;
      return Math.min(...days);
    },
    aggregateDaysToNewBudgetStrategy(children) {
      const days = this.nearestDaysToNewStrategy(children);
      return days === null ? null : Math.abs(days);
    },
    aggregateDaysToNewBudgetStrategyStatus(children) {
      return this.getDaysToNewStrategyStatus(this.nearestDaysToNewStrategy(children));
    }
  }
};